exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frameBox_2FhWq8Vv {\n    margin: 0 auto;\n}\n", ""]);

// exports
exports.locals = {
	"frameBox": "frameBox_2FhWq8Vv"
};